import { testIf } from '../validationFunctions';
import { mergeArrays } from '../../mergeFunctions';
import { successState, formatResults } from '../validationHelpers';

export const validateRegister = ({ data, setNotificationText }) => {
  const emptyRes = testIf('empty')(data, ['company', 'fullname', 'email', 'termsOfService']);
  const emailRes = testIf('email')(data, ['email']);
  const testResults = mergeArrays([emptyRes, emailRes]);
  if (testResults.length === 0) return successState(setNotificationText);
  setNotificationText(formatResults(testResults));
};
